export default function () {
	const listingBlock = document.querySelector( '.listing-block' );

	if ( ! listingBlock) {
		return;
	}

	let tileItem    = listingBlock.querySelectorAll( '.tile-item' );
	let tileItemSvg = listingBlock.querySelector( '.tile-item--svg' );

	if ( (tileItem.length - 1) % 4 == 0) {
		tileItemSvg.style.display = 'none'
	}

	tileItem.forEach(
		function (item, index) {
			item.addEventListener(
				'click',
				function (e) {
					let link = this.querySelector( '.tile-item__link' )
					if (e.target !== link) {
						if (this.classList.contains( 'active' )) {
							this.classList.remove( 'active' )
						} else {
							tileItem.forEach(
								function (item) {
									item.classList.remove( 'active' )
								}
							)
							this.classList.add( 'active' )
						}
					}
				}
			)
		}
	)

}
